import { api } from './client';
import type { LoginResponse, ValidateTrackingCodeResponse, RegisterResponse, User } from '../../types/auth';

export const authApi = {
  currentUser(): Promise<{ user: User }> {
    return api.request<{ user: User }>('/auth/me');
  },
  login(email: string, password: string): Promise<LoginResponse> {
    return api.request<LoginResponse>('/auth/login', {
      method: 'POST',
      body: { email_address: email, password } as any
    });
  },

  logout(): Promise<void> {
    return api.request('/auth/logout', { method: 'DELETE' });
  },

  forgotPassword(email: string): Promise<{ message: string }> {
    return api.request<{ message: string }>('/passwords/forgot', {
      method: 'POST',
      body: { email_address: email } as any
    });
  },

  resetPassword(token: string, password: string, passwordConfirmation: string): Promise<{ message: string }> {
    return api.request<{ message: string }>('/passwords/reset', {
      method: 'PUT',
      body: { token, password, password_confirmation: passwordConfirmation } as any
    });
  },

  validateTrackingCode(trackingNumber: string): Promise<ValidateTrackingCodeResponse> {
    return api.request<ValidateTrackingCodeResponse>('/registrations/validate_tracking_code', {
      method: 'POST',
      body: { tracking_number: trackingNumber } as any
    });
  },

  register(data: {
    tracking_number: string;
    password: string;
    password_confirmation: string;
    name: string;
  }): Promise<RegisterResponse> {
    return api.request<RegisterResponse>('/registrations', {
      method: 'POST',
      body: { registration: data } as any
    });
  },
};
